import * as React from 'react';

const Settings = React.lazy(() => import('../../Settings/Settings'))

const SettingsPage: React.FC = props => {
	return <React.Suspense fallback={<div>Загрузка...</div>}>
		<Settings />
	</React.Suspense>;
};

export default SettingsPage;
